import WebStorage from "./WebStorage";
import Events from "~/ts/library/Events";

class LocalStorage extends WebStorage {
    constructor() {
        super();
        Events.addEventListener("storage",  window,(e: StorageEvent) => {
            if (e.key && this.isOurKey(e.key)) {
                let key = this.removeOurPrefix(e.key);
                /*
                if (key.includes("isDialogRunning")) {
                    PUSH_TO_DEBUG_CONSOLE(JSON.stringify({
                        key,
                        newValue: e.newValue,
                        oldValue: e.oldValue,
                        hasInReactiveStorage: LocalStorage.hasInReactiveStorage(key)
                    }), true);
                }*/

                if (LocalStorage.hasInReactiveStorage(key)) {
                    if (e.newValue !== undefined) {
                        try {
                            LocalStorage.setInReactiveStorage(key, JSON.parse(e.newValue ?? ""));
                        } catch (e) {
                            LocalStorage.removeFromReactiveStorage(key);
                        }
                    } else {
                        LocalStorage.removeFromReactiveStorage(key);
                    }
                }
                LocalStorage.fireEvent(key, e);
            }
        });
    }

    protected getStorage(): Storage {
        return window.localStorage;
    }

    public isPersistent(): boolean {
        return true;
    }

    getType(): string {
        return "localStorage";
    }
}


export default LocalStorage;